import { CaseReducer, createReducer, UnknownAction } from '@reduxjs/toolkit';

import { IAuthState } from 'app/models';
import { authenticate, deauthenticate } from './actions';

const defaults: IAuthState = {};

export { authenticate, deauthenticate, signin, verify, signout } from './actions';
export { getSession, getUser, isPermitted } from './selectors';

export default createReducer(defaults, (builder) => {
  builder.addCase(authenticate, (state, { payload }) => ({ ...state, ...payload }));
  builder.addCase(deauthenticate, () => defaults);

  const commands = new Map<string, CaseReducer<IAuthState>>();
  commands.set('auth/reload', (state, { payload }) => (payload ?? state) as IAuthState);

  builder.addMatcher<UnknownAction>(({ type }) => commands.has(type), (state, action) => {
    return commands.get(action.type)!(state, action);
  });
});
